import React, { useEffect, useState } from "react";
import DateRowView from "./DateRowView";
import TimeSlotsView from "./TimeSlotsView";
import { AddressListResponse } from "src/types/location.types";
import { ScheduleScreenNames } from "src/types/common";
import analytics from "src/helpers/analytics";
import { SCREEN_NAMES } from "src/helpers/analytics/events";

interface ScheduleScreenProps {
  onDateTimeChange: (
    date: Date | null,
    timeSlot: string | null,
    slotId: string | null
  ) => void;
  screenName: ScheduleScreenNames;
  address?: AddressListResponse;
}

const ScheduleScreen: React.FC<ScheduleScreenProps> = ({
  onDateTimeChange,
  screenName,
  address,
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [displayedMonth, setDisplayedMonth] = useState({
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  });
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<string | null>(null);
  const [selectedTimeSlotId, setSelectedTimeSlotId] = useState<string | null>(
    null
  );

  useEffect(() => {
    // Event: SCHEDULE_SCREEN_VIEWED
    analytics.pageView(`${screenName}_${SCREEN_NAMES.SLOT_SELECTION_SCREEN}`);
  }, []);

  // Notify parent whenever date or time changes
  useEffect(() => {
    onDateTimeChange(selectedDate, selectedTimeSlot, selectedTimeSlotId);
  }, [selectedDate, selectedTimeSlot, selectedTimeSlotId]);

  const handleDateChange = (date: Date) => {
    setSelectedDate(date);
    setSelectedTimeSlot(null); // Reset time slot when date changes
    const month = date.getMonth();
    const year = date.getFullYear();
    if (month !== displayedMonth.month || year !== displayedMonth.year) {
      setDisplayedMonth({ month, year });
    }
  };

  const handleTimeSlotSelect = (time: string, slotId: string | null = null) => {
    setSelectedTimeSlot(time);
    setSelectedTimeSlotId(slotId);
  };

  return (
    <div className="flex-1 p-4 space-y-4 h-full">
      {/* Date Selector */}
      <div>
        {/* Date row and calendar toggle */}
        <DateRowView
          onDateSelect={handleDateChange}
          selectedDate={selectedDate}
          displayedMonth={displayedMonth}
        />
      </div>
      <h3 className="text-sm text-center font-semibold text-gray-700 mb-6">
        Available Time Slots
      </h3>
      <div className="flex-1 overflow-y-auto">
        <TimeSlotsView
          screenName={screenName}
          isSelectedDateChanged={selectedDate}
          onTimeSlotSelect={handleTimeSlotSelect}
          address={address}
        />
      </div>
    </div>
  );
};

export default ScheduleScreen;
